module.exports = __webpack_public_path__ + "img/product5.62ab0985.png";